import SetData from "@/vuex/SetData";
import Validate from "@/assets/Helper/Validate";
import Config from "@/vuex/Config";
import Logger from "@/assets/Helper/Logger";
import Wishlist from "@/assets/Wishlist";
import ConvertItem from "@/assets/DAO/Item/ConvertItem";
import Status from "@/vuex/Status";

class UrlClass {

    setItemnumbers(itemnumbers) {
        let title = "";

        if (Array.isArray(itemnumbers) && itemnumbers.length > 0 && itemnumbers[0] !== "") {
            if (itemnumbers.length === 1) {
                SetData.dispatch('setShowSetImage', false).catch((error) => {
                    Logger.error(error);
                });
                SetData.dispatch('setCurrentItem', 0).catch((error) => {
                    Logger.error(error);
                });
            }

            let itemStr = itemnumbers.join("/");
            let itemUrl = "/" + itemStr + "/";

            itemUrl = Config.getters.getIntegrationUrlPrafix + itemUrl;

            if (Config.getters.getIsOnlyWishlist !== true) {
                if (!window.history.state) {
                    window.history.replaceState({ uri: itemUrl }, title, itemUrl);
                } else if (window.history.state.uri && window.history.state.uri != itemUrl) {
                    window.history.pushState({ uri: itemUrl }, title, itemUrl);
                }
            } else {
                window.history.pushState({ uri: itemUrl }, title, itemUrl);
            }
        }
    }

    getFromHref(withSize) {
        let uriParts = window.location.href.split("/");
        uriParts.reverse();

        let itemnumbers = [];

        for (let uriPartsKey in uriParts) {
            uriParts[uriPartsKey] = uriParts[uriPartsKey].toUpperCase();
            if (uriParts[uriPartsKey] !== "" && Validate.isItemnumber(uriParts[uriPartsKey])) {
                if (withSize == false) {
                    let tmpParts = uriParts[uriPartsKey].split(':');
                    uriParts[uriPartsKey] = (tmpParts[0]) ? tmpParts[0] : uriParts[uriPartsKey];
                }

                itemnumbers.push(uriParts[uriPartsKey]);
            }
        }

        return itemnumbers;
    }

    getItemnumbers() {
        Status.dispatch("setIsInit", true);

        let itemnumbers = this.getFromHref(true);

        if (itemnumbers.length === 0 && window.location.hash !== "") {
            let hashStr = window.location.hash;
            hashStr = hashStr.replace("#", "");

            let hashParts = hashStr.split("|");
            hashParts[0] = hashParts[0].toUpperCase();

            if (Validate.isSet(hashParts[0]) || Validate.isItemnumber(hashParts[0])) {
                itemnumbers.push(hashParts[0]);

                SetData.dispatch('setSetIdParameters', {
                    "fineness": hashParts[1],
                    "height": hashParts[2],
                    "stoneQuality": hashParts[3],
                    "stonePriceType": hashParts[3]
                }).catch((error) => {
                    Logger.error(error);
                });
            }
        }

        itemnumbers.reverse();

        if (itemnumbers.length === 1 && Validate.isSet(itemnumbers[0])) {
            SetData.dispatch('setSetId', itemnumbers[0]).catch((error) => {
                Logger.error(error);
            });
            SetData.dispatch('setShowSetImage', true).catch((error) => {
                Logger.error(error);
            });
        } else if (typeof itemnumbers == 'object' && itemnumbers.length > 0) {
            ConvertItem.byItemnumber(itemnumbers).then(() => {
                let itemnumbers = SetData.getters.getItemnumbers;
                this.setItemnumbers(itemnumbers);

                SetData.dispatch('clearItems', true).catch((error) => {
                    Logger.error(error);
                });

                Wishlist.restoreDataFromWishlist(itemnumbers).then(result => {
                    if (result === false) {
                        SetData.dispatch("setItemnumbersStart", itemnumbers);

                        for (let i in itemnumbers) {
                            if (Object.prototype.hasOwnProperty.call(itemnumbers, i) && Validate.isItemnumber(itemnumbers[i])) {
                                SetData.dispatch('addItem', itemnumbers[i]).catch((error) => {
                                    Logger.error(error);
                                });
                            }
                        }

                        if (SetData.getters.getSetId != '' && itemnumbers.length > 1) {
                            SetData.dispatch('setShowSetImage', true).catch((error) => {
                                Logger.error(error);
                            });
                        }

                        if (itemnumbers.length === 1) {
                            SetData.dispatch('setCurrentItem', 0).catch((error) => {
                                Logger.error(error);
                            });
                        }
                    }
                });
            });
        }
    }
}

let Url = new UrlClass();

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        document.getElementById('app').style.display = 'none';
        document.location.reload();
        return;
    }
});

window.addEventListener('popstate', (event) => {
    if (document.location.href.indexOf(Config.getters.getIntegrationUrlPrafix) < 1 || Config.getters.getIsOnlyWishlist === true || Status.getters.isInit === true) {
        document.getElementById('app').style.display = 'none';
        document.location.reload();
        return;
    }
    event.state.ispopstate = true;

    let currentItemId = SetData.getters.getCurrentItemId;

    let itemnumbers = Url.getFromHref(true);
    itemnumbers.reverse();

    SetData.dispatch('clearItems', true).catch((error) => {
        Logger.error(error);
    });

    for (let i in itemnumbers) {
        itemnumbers[i] = itemnumbers[i].indexOf(':') > -1 ? itemnumbers[i].substring(0, itemnumbers[i].indexOf(':')) : itemnumbers[i];
        SetData.dispatch('addItem', itemnumbers[i]);
    }

    if (SetData.getters.getSetId != '') {
        SetData.dispatch('setShowSetImage', itemnumbers.length > 1 ? true : false).catch((error) => {
            Logger.error(error);
        });
    }

    Config.dispatch('setVisualMode', 'show').then(() => {
        SetData.dispatch('setCurrentItem', currentItemId).catch((error) => {
            Logger.error(error);
        });
    }).catch((error) => {
        Logger.error(error);
    });
});

export default Url;
